exports.SimpleTimer = require('./lib/simple-timer').SimpleTimer;



//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/ng2-simple-timer/index.js
// module id = ../../../../ng2-simple-timer/index.js
// module chunks = 4